import { render, staticRenderFns } from "./MaterialListModal.vue?vue&type=template&id=a2bedc94&scoped=true"
import script from "./MaterialListModal.vue?vue&type=script&lang=js"
export * from "./MaterialListModal.vue?vue&type=script&lang=js"
import style0 from "./MaterialListModal.vue?vue&type=style&index=0&id=a2bedc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bedc94",
  null
  
)

export default component.exports